// Video Grid js

document.addEventListener("DOMContentLoaded", function () {
  /********REMOVING UNWANTED ELEMENTS ON DIFFERENT SCREEN********/
  if(window.innerWidth >= 750){
    document.querySelectorAll(".desktop--hide")?.forEach(function(e){e.remove()});
  }else{
    document.querySelectorAll(".mobile--hide")?.forEach(function(e){e.remove()});
  }
  var videoContainers = document.querySelectorAll(".grid-video-container");

  videoContainers.forEach(function (videoContainer) {
    var video = videoContainer.querySelector(".customVideo");
    var playPauseBtn = videoContainer.querySelector(".playPauseBtn");

    playPauseBtn.addEventListener("click", function (event) {
      event.stopPropagation();
      togglePlayPause(video, playPauseBtn);
    });

    videoContainer.addEventListener("click", function () {
      togglePlayPause(video, playPauseBtn);
    });

    video.addEventListener("play", function () {
      playPauseBtn.classList.remove("play");
      playPauseBtn.classList.add("pause");
    });

    video.addEventListener("pause", function () {
      playPauseBtn.classList.remove("pause");
      playPauseBtn.classList.add("play");
    });
  });

  function togglePlayPause(video, playPauseBtn) {
    if (video.paused || video.ended) {
      video.play();
      playPauseBtn.classList.remove("play");
      playPauseBtn.classList.add("pause");
    } else {
      video.pause();
      playPauseBtn.classList.remove("pause");
      playPauseBtn.classList.add("play");
    }
  }
});


// Featured collection Js / Slider With tabs

document.addEventListener("DOMContentLoaded", function() {
  var swiper = new Swiper('.f_collection-slider', {
    slidesPerView: 2,
    spaceBetween: 6,
    grabCursor: true,
    keyboardControl: true,
    autoHeight: true,
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      749: {
        slidesPerView: 3,
        spaceBetween: 11
      },
      1080: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
  });
});


// Custom testimonial slider
document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.testimonial-slider-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      749: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      1080: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  });
});


// Logo slider Js with tabs

// document.addEventListener("DOMContentLoaded", function() {
//   var swiper = new Swiper('.logo-slider', {
//     slidesPerView: 3,
//     spaceBetween: 10,
//     loop: true,
//     centeredSlides: true,
//     initialSlide: 1, 
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//     breakpoints: {
//       749: {
//         slidesPerView: 3,
//         spaceBetween: 15
//       },
//       1080: {
//         slidesPerView: 5,
//         spaceBetween: 20
//       }
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function() {
  var swiper = new Swiper('.logo-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    centeredSlides: true,
    initialSlide: 1, 
    navigation: {
      nextEl: '.logo_slider-next',
      prevEl: '.logo_slider-prev',
    },
    breakpoints: {
      510: {
        slidesPerView: 3,
        spaceBetween: 15
      },
      1080: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    },
    on: {
      init: function() {
        changeTabContent(this.realIndex);
      },
      slideChange: function() {
        changeTabContent(this.realIndex);
      }
    }
  });

  function changeTabContent(index) {
    var tabContents = document.querySelectorAll('.tab-content');
    
    tabContents.forEach(function(content, idx) {
      content.style.display = (idx === index) ? 'block' : 'none';
    });
  }
});


// Multicolumn Mobile Slider

document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.multicolumn-v2-swiper');
  sliders.forEach(function(slider) {
    var swiper = new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          enabled: false 
        },
      }
    });
  });
});


// Image with FAQ / Accordions
$(document).ready(function() {
  $('.image-with-faqs-section .accordion-item').each(function() {
    const $icon = $(this).find('.icon');
    if ($(this).hasClass('active')) {
      $icon.text('-');
      $(this).find('.ans-content').show();
    } else {
      $icon.text('+');
    }
  });

  $('.image-with-faqs-section .quest-wrapper').off('click').on('click', function(event) {
    event.stopPropagation();
    const $accordionItem = $(this).closest('.accordion-item');
    const $container = $(this).closest('.image-with-faqs-section');

    $container.find('.ans-content').not($accordionItem.find('.ans-content')).slideUp();
    $container.find('.accordion-item').not($accordionItem).removeClass('active');
    $container.find('.accordion-item').not($accordionItem).find('.icon').text('+');

    $accordionItem.toggleClass('active');
    $accordionItem.find('.ans-content').stop(true, true).slideToggle();
    $accordionItem.find('.icon').text($accordionItem.hasClass('active') ? '-' : '+');
  });
});


// Custom Popup Js
// document.addEventListener('DOMContentLoaded', function() {
//   var openPopupLinks = document.querySelectorAll('a[href="#custompopup"]');
//   openPopupLinks.forEach(function(link) {
//     link.addEventListener('click', function(event) {
//       event.preventDefault();
//       document.getElementById('custompopup').style.display = 'flex';
//       window.history.replaceState(null, null, ' ');
//     });
//   });

//   var closePopupButton = document.querySelector('.custom-popup-close');
//   closePopupButton.addEventListener('click', function() {
//     document.getElementById('custompopup').style.display = 'none';
//     window.history.replaceState(null, null, ' ');
//   });
// });
// search suggestions
document.addEventListener("DOMContentLoaded", function() {
  // Function to attach the search event listener
  function attachSearchListener() {
    var searchInput = document.getElementById('search-input');
    var popularTermsWrapper = document.getElementById('popular-terms-wrapper');

    if (searchInput && popularTermsWrapper) {
      console.log("Search input element found."); // Debug log
      searchInput.addEventListener('input', function() {
        var query = searchInput.value.trim();

        if (query.length < 1) {
          popularTermsWrapper.innerHTML = ''; // Clear suggestions if query is too short
          return;
        }

        fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
          .then(response => response.json())
          .then(data => {
            const suggestions = data.resources.results.products;
            popularTermsWrapper.innerHTML = ''; // Clear previous suggestions

            if (suggestions.length > 0) {
              const termsSet = new Set();

              suggestions.forEach(suggestion => {
                const terms = suggestion.title.toLowerCase().split(' '); // Split into words
                terms.forEach(term => {
                  const trimmedTerm = term.trim();
                  if (trimmedTerm.length > 2) { // Filter out short terms
                    termsSet.add(trimmedTerm); // Add valid term to set
                  }
                });
              });

              const termsArray = Array.from(termsSet); // Convert set back to array

              // Create and append list items for each unique term
              const ul = document.createElement("ul");
              ul.classList.add("search--popular__terms-wrapper", "no-bullets", "flex-full");

              termsArray.forEach(term => {
                const li = document.createElement("li");
                li.classList.add("search--popular__terms-item");
                li.setAttribute("popularSearchItem", "");
                li.textContent = term;

                li.addEventListener('click', function() {
                  searchInput.value = term; // Set clicked term as search input value
                  searchInput.dispatchEvent(new CustomEvent('input'));
                });

                ul.appendChild(li);
              });
              // Add title for popular terms
              const popularTermsTitle = document.createElement("div");
              popularTermsTitle.classList.add("search--popular__term-title");
              popularTermsTitle.textContent = "Most Popular search terms";
              popularTermsWrapper.appendChild(popularTermsTitle);
              popularTermsWrapper.appendChild(ul);

            } else {
              popularTermsWrapper.innerHTML = '<p>No popular terms found</p>';
            }
          })
          .catch(error => {
            console.error('Search suggestion request failed:', error);
            popularTermsWrapper.innerHTML = '<p>Error fetching popular terms</p>';
          });
      });
    } else {
      //console.error("Search input or popular terms wrapper element not found.");
    }
  }

  // Function to clear search suggestions
  function clearSearchSuggestions() {
    var popularTermsWrapper = document.getElementById('popular-terms-wrapper');
    if (popularTermsWrapper) {
      popularTermsWrapper.innerHTML = ''; // Clear suggestions wrapper content
    }
  }

  // Use MutationObserver to detect when the search input or drawer is added or removed
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          // Check if search input or drawer is added
          if (node.id === 'search-input' || (node.classList && node.classList.contains('drawer--right'))) {
            attachSearchListener(); // Reattach search listener
          }
          // Check if .search-drawer--clear button is added
          if (node.classList && node.classList.contains('search-drawer--clear')) {
            node.addEventListener('click', function() {
              clearSearchSuggestions();
            });
          }
        });
      }

      if (mutation.removedNodes && mutation.removedNodes.length > 0) {
        mutation.removedNodes.forEach(function(node) {
          // Check if search drawer is removed
          if (node.classList && node.classList.contains('drawer--right')) {
            clearSearchSuggestions(); // Clear suggestions on drawer close
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Event listener for clearing search suggestions
  document.addEventListener('click', function(event) {
    if (event.target.matches('.search-drawer--clear')) {
      // alert('a');
      clearSearchSuggestions();
    }
  });
  
  // Initial check in case the input field or drawer is already present
  attachSearchListener();
});


// end search
document.addEventListener('DOMContentLoaded', function() {
  var openPopupLinks = document.querySelectorAll('a[href="#custompopup"]');
  openPopupLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      document.getElementById('custompopup').classList.add('show');
      window.history.replaceState(null, null, ' ');
    });
  });

  var closePopupButton = document.querySelector('.custom-popup-close');
  if(closePopupButton != null){
    closePopupButton.addEventListener('click', function() {
      document.getElementById('custompopup').classList.remove('show');
      window.history.replaceState(null, null, ' ');
    });
  }
});



// Reveal images animation
document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.reveal-image');
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    });

    images.forEach(image => {
        observer.observe(image);
    });
});


// Product Title Wrapping JS
 document.addEventListener("DOMContentLoaded", function() {
    const titles = document.querySelectorAll(".product-title");
    titles.forEach(title => {
        const text = title.innerHTML;
        if (text.includes("PERFUME OIL")) {
            const newText = text.replace("PERFUME OIL", "<br>PERFUME OIL");
            title.innerHTML = newText;
        }
    });

});


/*******RECENTLY VIEWED FUNCTIONALITY******/

window.theme = window.theme || {};

theme.initWhenVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

function isStorageSupported (type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = 'flow:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  }
  catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    
    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported('local')) {
      const productId = parseInt(this.dataset.productId);
      if(!isNaN(productId)){
      const cookieName = 'flow:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');
      
      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 5)));
      }
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('recently-viewed-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          
          /*******SWIPER SLIDER INITIATION******/
          var swiper = new Swiper('.recently-viewed-slider', {
            slidesPerView: 2.5,
            centerInsufficientSlides: true,
            spaceBetween: 25,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 1.3
              },
              600: {
                slidesPerView: 2.3
              }
            }
          });
          /*******SWIPER SLIDER INITIATION(Cart Page)******/
          var swiper = new Swiper('.cart--page--rc--products .swiper', {
            slidesPerView: 4,
            slidesPerGroup: 1, 
            centerInsufficientSlides: true,
            spaceBetween: 25,
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 2,
                slidesPerGroup: 1
              },
              600: {
                slidesPerView: 2,
                slidesPerGroup: 1
              },
              1024: {
                slidesPerView: 3,
                slidesPerGroup: 1
              },
              1200: {
                slidesPerView: 4,
                slidesPerGroup: 1, 
                loop: true
              }
            }
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getQueryString() {
    const cookieName = 'flow:recently-viewed';
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items.map((item) => "id:" + item).slice(0, 4).join(" OR ");
  }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);

/********CART RECOMMENDATION PRODUCT FUNCTIONALITY*******/
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  getFirstCartItemProductId() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length > 0) {
          return cart.items[0].product_id;
        } else {
          return null;
        }
      });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    let crsectionUrl = new URL(this.dataset.url, window.location.origin);
    if (crsectionUrl.searchParams.get("product_id")) {
      crsectionUrl = crsectionUrl;
      this.cartFetch(crsectionUrl);
    } else {
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let cartFirstItemId = null;
        
        if (cart.items.length > 0) {
          cartFirstItemId = cart.items[0].product_id;
        }

        crsectionUrl.searchParams.set('product_id', cartFirstItemId);
        this.cartFetch(crsectionUrl);
      });
    }
  }

  cartFetch(crsectionUrl){
    fetch(crsectionUrl.href)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          /*******SWIPER SLIDER INITIATION******/
          var swiper = new Swiper('.cart-recommendation-slider', {
            slidesPerView: 2.5,
            centerInsufficientSlides: true,
            spaceBetween: 25,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 1.3
              },
              600: {
                slidesPerView: 2.3
              }
            }
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);

document.addEventListener('DOMContentLoaded', function() {
  // Function to handle click event
  function handleViewOptionsClick(event) {
    event.preventDefault();
    var productUrl = event.target.getAttribute('data-product-url');
    window.location.href = productUrl;
  }

  // Function to add click event listener to view options button
  function addViewOptionsClickListener() {
    var viewOptionsButtons = document.querySelectorAll('.view-options-button-cstm');
    viewOptionsButtons.forEach(function(button) {
      if (!button.hasListener) {
        button.addEventListener('click', handleViewOptionsClick);
        button.hasListener = true; // Mark this button to avoid adding multiple listeners
      }
    });
  }

  // MutationObserver to detect changes in the DOM
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        addViewOptionsClickListener();
      }
    });
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial call to add event listeners to existing buttons
  addViewOptionsClickListener();
});

function fetchMetaData() {
  $.ajax({
    type: 'GET',
    url: '/cart.json',
    dataType: 'json', // Use 'json' instead of 'jsonp'
    success: function(data) {
      if (data.item_count > 0) {
      // Iterate over cart items to log selling plan info if available
        data.items.forEach(function(item, index) {
        var itemElement = $(".ajaxcart__product").eq(index);
        if (item.selling_plan_allocation) {
          var sellingPlanName = item.selling_plan_allocation.selling_plan.name;
          itemElement.find('span.subscription-allocation-name').text(sellingPlanName);
          console.log("Selling Plan Added");
        } else {
          console.log('No selling plan for this item');
        }
      });
      } else {
        console.log('Cart is empty.');
      }
    },
    error: function(xhr, status, error) {
      console.error('Error fetching cart data:', error);
    }
  });
}

$(".js-drawer-open-right-link, .cart-drawer--remove-btn").on("click", function() {
  setTimeout(function() {
    fetchMetaData();
  }, 500);
})
$(".ajaxcart__qty").on("click", function() {
  setTimeout(function() {
    fetchMetaData();
  }, 500);
})



